/** =================== Color Constants ==================== */
export const COLORS = {
    primary: '#8DCB2C',
    secondary: '#000000',
    danger: '#DC3545',
    info: '#17A2B8',
    light: '#F8F9FA',
    dark: '#343A40',
};
